import http from "../../auth/http-common";
import { URL } from "../../constants/api-constants";

const getCount = async (): Promise<number | undefined> => {
  try {
    const response = await http.get(URL.CONTROLLERS_COUNT);
    return response.data.count;
  } catch (error) {
    console.error(error);
  }
};

export const controllersProvider = {
  getCount,
};
